import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Header from "../Layout/Header";
import Footer from "../Layout/Footer";
import Whychoosetest from "./Whychoosetest";
import Propertyarea from "./Propertyarea";
import Qouta from "./Qouta";
import Propertyvideo from "./Propertyvideo";
import About from "./About";
import Feedback from "./Feedback";
import Ourteam from "./Ourteam";
import Category from "./Category";
import { useDispatch, useSelector } from "react-redux";
import { allapiAction } from "../../Redux/common/action";
import FooterNew from "../Layout/FooterNew";
import HomeSlider from "./HomeSlider";
// import Cityarea from './Cityarea'

function HomeComponents() {
  const get_home_all_pro = useSelector((state) =>
    state?.allapi?.get_home_all_pro ? state?.allapi?.get_home_all_pro : {}
  );
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(allapiAction.gethomePro({}));
    dispatch(allapiAction.getsliderList({ page: "home" }));
    // dispatch(allapiAction.getsliderList({ page: "home" }));
    // dispatch(allapiAction.getMarqueesList2({ page: "home" }));
  }, []);

  return (
    <div>
      <Header />
      <div></div>
      <div className="hmpg">
      <div className="sliderHight"></div>
        <HomeSlider homedata={get_home_all_pro} />

        {/* <!-- main-start --> */}
        {/* <div class="container-fluid mt-5">
        <div class="row pt-3 ">
            <div id="carouselExampleIndicators" class="carousel slide p-0" data-bs-ride="carousel">
                <div class="carousel-indicators">
                    <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="0"
                        class="active" aria-current="true" aria-label="Slide 1"></button>
                    <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="1"
                        aria-label="Slide 2"></button>
                
                </div>
                <div class="carousel-inner">
                    <div class="carousel-item active" data-bs-interval="4000">
                        <img src="img/a1.jpg" class="d-block w-100" alt="..."/>
                    </div>
                    <div class="carousel-item" data-bs-interval="4000">
                        <img src="img/a2.jpg" class="d-block w-100" alt="..."/>
                    </div>
                   
                </div>
           
            </div>
        </div>
    </div> */}
        <div className="whychooseete">
          <Whychoosetest />
        </div>
        <Propertyarea />
        <Qouta />
        <Ourteam/>
        <Propertyvideo />
        <About />
        <Feedback />
        {/* <Category homedata={get_home_all_pro} /> */}
        {/* <Cityarea/> */}
      </div>
      {/* <!-- main-end -->



    <!-- main-start-1 --> */}
      {/* <div class="container mt-4">
        <div class="row">
            <h1 class="fw-bold">EARN UP TO <span class="main-1-hadding"> 30 % MONTHLY</span></h1>
            <div class="mt-2">
                <button class="btn fw-bold fw-bold main-1-button rounded-pill">Get Started</button>
            </div>
        </div>
    </div> */}

      {/* <!-- main-end-1 -->


    <!-- main-start-2 --> */}
      {/* <div class="video-container">
        <iframe 
            src="https://www.youtube.com/embed/n9FW_KlXGCc?si=idiZe67_PeNCnsNi" 
            title="YouTube video player" 
            frameborder="0" 
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
            referrerpolicy="strict-origin-when-cross-origin" 
            allowfullscreen>
        </iframe>
    </div> */}

      {/* <!-- main-end-2 -->


    <!-- main-start-3 --> */}
      {/* <div class="container mt-4">
        <div class="row">
            <div class="swiper mySwiper">
                <div class="swiper-wrapper">
                    <div class="swiper-slide"><img src="img/a.png" alt="Image 1"/></div>
                    <div class="swiper-slide"><img src="img/b.png" alt="Image 2"/></div>
                    <div class="swiper-slide"><img src="img/c.png" alt="Image 3"/></div>
                    <div class="swiper-slide"><img src="img/d.png" alt="Image 4"/></div>
                    <div class="swiper-slide"><img src="img/e.png" alt="Image 1"/></div>
                    <div class="swiper-slide"><img src="img/f.png" alt="Image 2"/></div>
                    <div class="swiper-slide"><img src="img/g.png" alt="Image 3"/></div>
                    <div class="swiper-slide"><img src="img/h.png" alt="Image 4"/></div>
                </div>
                <div class="swiper-button-next"></div>
                <div class="swiper-button-prev"></div>
                <div class="swiper-pagination"></div>
            </div>
        </div>
    </div> */}

      {/* <!-- main-end-3 -->

    <!-- main-start-4 --> */}
      {/* <div class="container-fluid mt-4">
        <div class="row main-4-backgroundcolor ">
            <div class="row p-4">
                <div class="col-12 col-lg-4">
                    <h2 class="text-center text-dark fw-bold">"Explore, discover, and earn big with   Gatway Landmark Group Company—one of the top trading platforms in the world!"</h2>
                </div>


                <div class="col-12 col-lg-4 mt-2">
                    <div class="d-flex">
                        <div><img src="img/icon_cardTick_01.webp" alt=""/></div>
                        <div class="m-2 text-dark">
                            <h3 class="fw-bold">Multi-Reward System</h3>
                            <p>"  Gatway Landmark Group utilizes a proprietary algorithmic trading model, providing dual earning opportunities through trading rewards and referral bonuses."**</p>
                        </div>
                    </div>
                </div>


                <div class="col-12 col-lg-4 mt-2">
                    <div class="d-flex">
                        <div><img src="img/icon_histogram_01.png" alt=""/></div>
                        <div class="m-2 text-dark">
                            <h3 class="fw-bold">Earn Future Value</h3>
                            <p>"  Gatway Landmark Group simplifies forex trading by offering innovative trading solutions and a rewarding financial model, making global markets more accessible to everyone."</p>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div> */}

      {/* <!-- main-end-4 -->

    <!-- main-start-5 --> */}
      {/* <div class="container mt-4">
        <div class="row">
            <div class="d-flex justify-content-center align-items-center">
                <img class="w-100" src="img/rs.jpg" alt=""/>
            </div>
        </div>
    </div> */}

      {/* <!-- main-end-5 --> */}

      {/* <!-- main-start-6 --> */}

      {/* <!-- main-end-6 --> */}

      {/* <!-- main-start-7 --> */}

      {/* <!-- main-end-7 --> */}

      {/* <!-- main-start-8 --> */}
      {/* <div class="container mt-4">
        <div class="row">
            <div>
                <h5 class="fw-bold">TOP COLLECTIONS OVER</h5>
                <div class="d-flex justify-content-between">
                    <p class="text-muted"> <small>Last 24 Hours</small></p>

                    <a class="text-decoration-none" href="">
                        <p class="fw-bold text-dark"> <small>More </small><img class="w-25"
                                src="img/icons8-right-arrow-24.png" alt=""/></p>
                    </a>
                </div>
            </div>

            <div class="d-flex justify-content-between">
                <div class="d-flex gap-2">
                    <div>
                        <h5 class="fw-bold mt-2 pt-1">1</h5>
                    </div>
                    <div>
                        <img src="img/rounded a.png" alt=""/>
                    </div>
                    <div>
                        <h6 class="mt-1">The Cryto Lucky Girl</h6>
                        <div class="d-flex gap-2 main-8-tlogo">
                            <div>
                                <img src="img/t logo.png" alt=""/>
                            </div>
                            <div>
                                <h6 class="text-muted fw-bold mt-1"><small>3.98B</small></h6>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="main-8-color">
                    <h5 class="fw-bold mt-2 pt-1"> + 2.26%</h5>
                </div>
            </div>
            <div>
                <hr/>
            </div>

            <div class="d-flex justify-content-between">
                <div class="d-flex gap-2">
                    <div>
                        <h5 class="fw-bold mt-2 pt-1">2</h5>
                    </div>
                    <div>
                        <img src="img/rounded b.png" alt=""/>
                    </div>
                    <div>
                        <h6 class="mt-1">Pixels Pink</h6>
                        <div class="d-flex gap-2 main-8-tlogo">
                            <div>
                                <img src="img/t logo.png" alt=""/>
                            </div>
                            <div>
                                <h6 class="text-muted fw-bold mt-1"><small>3.98B</small></h6>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="main-8-color">
                    <h5 class="fw-bold mt-2 pt-1"> + 2.22%</h5>
                </div>
            </div>
            <div>
                <hr/>
            </div>


            <div class="d-flex justify-content-between">
                <div class="d-flex gap-2">
                    <div>
                        <h5 class="fw-bold mt-2 pt-1">3</h5>
                    </div>
                    <div>
                        <img src="img/rounded c.png" alt=""/>
                    </div>
                    <div>
                        <h6 class="mt-1">PEPE Frog Nobility</h6>
                        <div class="d-flex gap-2 main-8-tlogo">
                            <div>
                                <img src="img/t logo.png" alt=""/>
                            </div>
                            <div>
                                <h6 class="text-muted fw-bold mt-1"><small>3.98B</small></h6>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="main-8-color">
                    <h5 class="fw-bold mt-2 pt-1"> + 2.19%</h5>
                </div>
            </div>
            <div>
                <hr/>
            </div>


            <div class="d-flex justify-content-between">
                <div class="d-flex gap-2">
                    <div>
                        <h5 class="fw-bold mt-2 pt-1">4</h5>
                    </div>
                    <div>
                        <img src="img/rounded d.png" alt=""/>
                    </div>
                    <div>
                        <h6 class="mt-1">Noxious Audience</h6>
                        <div class="d-flex gap-2 main-8-tlogo">
                            <div>
                                <img src="img/t logo.png" alt=""/>
                            </div>
                            <div>
                                <h6 class="text-muted fw-bold mt-1"><small>3.98B</small></h6>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="main-8-color">
                    <h5 class="fw-bold mt-2 pt-1"> + 2.2%</h5>
                </div>
            </div>
            <div>
                <hr/>
            </div>


            <div class="d-flex justify-content-between">
                <div class="d-flex gap-2">
                    <div>
                        <h5 class="fw-bold mt-2 pt-1">5</h5>
                    </div>
                    <div>
                        <img src="img/rounded a.png" alt=""/>
                    </div>
                    <div>
                        <h6 class="mt-1">Giffgaff Ape Club </h6>
                        <div class="d-flex gap-2 main-8-tlogo">
                            <div>
                                <img src="img/t logo.png" alt=""/>
                            </div>
                            <div>
                                <h6 class="text-muted fw-bold mt-1"><small>3.98B</small></h6>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="main-8-color">
                    <h5 class="fw-bold mt-2 pt-1"> + 2.19%</h5>
                </div>

            </div>
        </div>
    </div> */}

      {/* <!-- main-end-8 --> */}

      {/* <!-- main-start-9 --> */}
      {/* <div class="container mt-4 main-9-backgroundcolor p-3">
        <div class="row">
            <h4 class="fw-bold text-center mt-2 text-dark">FEATURES Package COLLECTIBLES</h4>
            <div class="d-flex justify-content-between mt-3">
                <div class="">
                    <img class="w-100 rounded-4" src="https://www.shareindia.com/wp-content/uploads/2023/12/Decoding-Forex-Trading.webp" alt=""/>
                </div>
                <div class="p-1">
                    <div class="">
                        <img class="w-100 rounded-4" src="img/ss.jpg" alt=""/>
                    </div>

                   
                </div>
            </div>
            <h5 class="fw-bold mt-2 text-dark">EARN MONEY</h5>
            <div class="d-flex justify-content-between">
                <div>
                    <h6 class="fw-bold text-dark">From   Gatway Landmark Group</h6>
                </div>
                <div>
                    <button class="btn rounded-pill main-9-btn fw-bold btn-sm"> TOTAL 4 TEAM</button>
                </div>
            </div>




            <div class="d-flex justify-content-between mt-4">
                <div class="">
                    <img class="w-100 rounded-4" src="https://financefeeds.com/wp-content/uploads/2022/08/Forex.jpeg" alt=""/>
                </div>
                <div class="p-1">
                    <div class="">
                        <img class="w-100 rounded-4" src="img/ss.jpg" alt=""/>
                    </div>

                 
                </div>
            </div>
            <h5 class="fw-bold mt-2 text-dark">EARN MONEY</h5>
            <div class="d-flex justify-content-between">
                <div>
                    <h6 class="fw-bold text-dark">From   Gatway Landmark Group</h6>
                </div>
                <div>
                    <button class="btn rounded-pill main-9-btn fw-bold btn-sm"> TOTAL 4 TEAM</button>
                </div>
            </div>



            <div class="d-flex justify-content-between mt-4">
                <div class="">
                    <img class="w-100 rounded-4" src="https://media.licdn.com/dms/image/v2/D5612AQFoiYnVJtIvTQ/article-cover_image-shrink_720_1280/article-cover_image-shrink_720_1280/0/1728965728618?e=2147483647&v=beta&t=4fZhEJAgHiojKmyc-3viS3W8LeI1ZUw15BcQEwINDiU" alt=""/>
                </div>
                <div class="p-1">
                    <div class="">
                        <img class="w-100 rounded-4" src="img/GIRL B.png" alt=""/>
                    </div>

                    <div class="mt-2">
                        <img class="w-100 rounded-4" src="img/GIRL C.png" alt=""/>
                    </div>

                    <div class="mt-2">
                        <img class="w-100 rounded-4" src="img/GIRL D.png" alt=""/>
                    </div>
                </div>
            </div>
            <h5 class="fw-bold mt-2 text-dark">EARN MONEY</h5>
            <div class="d-flex justify-content-between">
                <div>
                    <h6 class="fw-bold text-dark">From   Gatway Landmark Group</h6>
                </div>
                <div>
                    <button class="btn rounded-pill main-9-btn fw-bold btn-sm"> TOTAL 4 TEAM</button>
                </div>
            </div>




        </div>
    </div> */}

      {/* <!-- main-end-9 --> */}

      {/* <!-- main-start-10 --> */}
      {/*  */}

      {/* <!-- main-end-10 --> */}

      {/* <!-- main-start-11 --> */}

      {/* 
    <!-- main-end-11 --> */}
      <Footer />
      <FooterNew />
    </div>
  );
}

export default HomeComponents;
